import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { NotificationService } from 'src/app/core/notification.service'
import { TranslatorService } from 'src/app/core/translator.service'
import { scrollToFirstInvalidControl } from 'src/app/shared/until'
import { AccessRights } from '../../role/user-role/user-role'
import { ConfigurationOption } from '../configuration-option'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Subject } from 'rxjs'
import { withLatestFrom } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import { DEFAULT_YEAR_MATRIX } from 'src/app/shared/constants'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
@UntilDestroy()
@Component({
  selector: 'configuration-option-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class ConfigurationOptionFormComponent implements OnInit {
  @Output()
  onSubmit = new EventEmitter<any>()
  @Output()
  onPatch = new EventEmitter<any>()
  @Input()
  configurationOption: ConfigurationOption

  public getDataFromCalendar$: Subject<boolean> = new Subject()
  public showCalendar: boolean = false
  public form: UntypedFormGroup
  public accessRights = AccessRights
  public isCreatedBeforeConfigOptions: boolean = false
  public sendCalendar$: Subject<any> = new Subject()
  constructor(
    private fb: UntypedFormBuilder,
    public store: Store<AppState>,
    private translatorService: TranslatorService,
    private elementRef: ElementRef,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      value: [null, [Validators.required]],
      key: [null, [Validators.required]]
    })
    this.form.controls.key.valueChanges
      .pipe(
        untilDestroyed(this),
        withLatestFrom(
          this.store.select(configurationOptionSelectors.selectAll),
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole)
        )
      )

      .subscribe(([key, configOptions, currentUser]) => {
        if (key == DEFAULT_YEAR_MATRIX) {
          this.showCalendar = true
        } else {
          this.showCalendar = false
        }
        if (
          configOptions.find(
            (opt) => opt.key == key && opt.siteId == currentUser.siteId
          ) &&
          !this.configurationOption
        ) {
          this.isCreatedBeforeConfigOptions = true
          this.form.controls.value.setValue(
            configOptions.find(
              (opt) => opt.key == key && opt.siteId == currentUser.siteId
            ).value
          )
          this.sendCalendar$.next(this.form.controls.value?.value?.split(''))
        } else if (this.configurationOption) {
          this.isCreatedBeforeConfigOptions = true
        }
      })
  }

  onFormSubmit() {
    if (this.form.invalid && !this.showCalendar) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })

      scrollToFirstInvalidControl(this.elementRef, this.notificationService)
      console.log('%cForm is invalid', 'color: red; font-weight: bold;')
      return
    }
    if (this.showCalendar) {
      this.getDataFromCalendar$.next(true)
    }
    if (!this.isCreatedBeforeConfigOptions) {
      this.onSubmit.emit(this.form.value)
    } else {
      this.onPatch.emit(this.form.value)
    }
  }
  public transformData(data) {
    this.form.controls.value.setValue(data.toString().replaceAll(',', ''))
  }
}
